/**
 * Semantic status surface colors for non-pill chrome (borders, tinted panels).
 * Values are CSS variables from index.jsx — mode-aware via data-theme.
 * Prefer StatusPill for chips/labels; use this only when you need raw color triples.
 */

const TOKEN = (name) => ({
  color: `var(--status-${name}-color)`,
  bg: `var(--status-${name}-bg)`,
  border: `var(--status-${name}-border)`,
});

const NEUTRAL = {
  color: 'var(--color-text-secondary)',
  bg: 'var(--color-bg-subtle)',
  border: 'var(--color-border)',
};

/** Stable palette object — no light/dark JS branching. */
export const STATUS_TOKEN_PALETTE = {
  green: TOKEN('green'),
  greenAlt: TOKEN('green'),
  red: TOKEN('red'),
  redAlt: TOKEN('red'),
  amber: TOKEN('amber'),
  amberAlt: TOKEN('amber'),
  blue: TOKEN('blue'),
  blueAlt: TOKEN('blue'),
  blueDark: TOKEN('blue'),
  zinc: NEUTRAL,
  zincAlt: NEUTRAL,
  purple: TOKEN('purple'),
  // No dedicated teal/cyan/indigo tokens — map to nearest status semantic.
  teal: TOKEN('green'),
  tealAlt: TOKEN('green'),
  cyan: TOKEN('blue'),
  indigo: TOKEN('purple'),
};

export function useStatusPalette() {
  return STATUS_TOKEN_PALETTE;
}

export function statusPaletteFor(_mode) {
  return STATUS_TOKEN_PALETTE;
}

/** Workflow component-run status → StatusPill variant (Canvas / session progress). */
export const COMPONENT_RUN_STATUS_VARIANT = {
  FAIL: 'red',
  PAUSED: 'amber',
  SUCCESS: 'green',
  SUCCESS_END: 'green',
  INPROGRESS: 'working',
  WAITING: 'waiting',
  TERMINATED: 'red',
};

export const COMPONENT_RUN_STATUS_LABELS = {
  FAIL: 'Error',
  INPROGRESS: 'In Progress',
};

/** Text color for a StatusPill / component-run variant. */
export function statusTextColorForVariant(variant) {
  if (variant === 'neutral') return STATUS_TOKEN_PALETTE.zinc.color;
  if (variant === 'working') return STATUS_TOKEN_PALETTE.purple.color;
  if (variant === 'waiting') return STATUS_TOKEN_PALETTE.amber.color;
  return STATUS_TOKEN_PALETTE[variant]?.color || STATUS_TOKEN_PALETTE.zinc.color;
}
